import React, { useEffect, useState, useRef } from "react";
import classes from "../../style/Style.module.css";
import "../../style/Nriscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../../Images/UpdatedDexter-call.svg";
import {
  Address_Verification,
  ROUTE_DXTER_SCANNING,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,ROUTE_ACCOUNT_TYPE,Gender_Dob_Verification,ROUTE_OCCUPATION,
  ROUTE_PLACEOF_BIRTH,ROUTE_CHECKBOXES,ROUTE_NOMINEE_DETAILS,ROUTE_NOMINEE_SENDOTP,
  ROUTE_NRI_TaxResidency
} from "../../Routes";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import statesList from "../../Components/StateList";
import { useSelector } from "react-redux";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import axios from "../../libs/axiosConfig";
import {

  ROUTE_NRI_TAXID_NUMBER,
} from "../../Routes";
import { useDispatch } from "react-redux";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";
import BirthCountryCode from "../../Components/CountrynameCode";

const TaxResidencyNRI = () => {
  const dispatch = useDispatch();
  const [TaxStatus, setTaxStatus] = useState("NRI Repatriable");
  const [Residency, setResidencyStatus] = useState("Yes");
  const [pincode, setPincode] = useState("");
  const [NRICity, setNRICity] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const Navigate = useNavigate();

  const dropdownRef = useRef(null);
  const [SuggestionsTaxStatus, setSuggestionsTaxStatus] = useState(false);
  const [showSuggestionsTaxStatus, setShowSuggestionsTaxStatus] =
    useState(false);
  const [showSuggestionsResidency, setShowSuggestionsResidency] =
    useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const [showModal, setShowModal] = useState(false);

  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [isLoading, setIsLoading] = useState(false);
  const [residentType, setResidentType] = useState("");

  const NRIStatus = ["NRI Repatriable", "NRI Through NRO A/c"];

  const [CountryOfResidency, setCountryOfResidency] = useState("");
  const [showSuggestionsCountry, setShowSuggestionsCountry] = useState(false);
  const [SuggestionsCountryCode, setSuggestionsCountryCode] = useState("");

  const handleCountryOfResidencyChange = (e) => {
    setCountryOfResidency(e.target.value);
  };

  const handleCountryOfResidencyListShow = () => {
    if (Residency === "Yes") {
      setShowSuggestionsCountry(!showSuggestionsCountry);
    } else {
      setCountryOfResidency("India");
    }
  };

  const handleCountryOfResidencySuggestionClick = (selectedCountry) => {
    const selectedCountryObject = BirthCountryCode.find(
      (country) => country.name === selectedCountry
    );

    if (selectedCountryObject) {
      setCountryOfResidency(selectedCountry);
      setShowSuggestionsCountry(false);
      const countryCode = selectedCountryObject.code;
      console.log("Selected Country Code:", countryCode);
      setSuggestionsCountryCode(countryCode);
    }
  };

  useEffect(() => {
    const fetchBasicQuestions = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${storedToken}`,
          // RefreshToken: refreshToken
        };
        const requestBody = {
          dexterrCustomerBasicQuestions: {
            mobile_no: phoneNumber,
            country_code: "+91",
            request_type: "get",
          },
        };

        const response = await axios.post(
          " https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          requestBody,
          { headers }
        );
        setResidentType(response.data.data.resident);

        if (
          response.data &&
          response.data.data.resident !== "Resident Indian"
        ) {
          setSuggestionsTaxStatus(NRIStatus);
          setResidentType(response.data.data.resident);
        }
      } catch (error) {
        console.error("Error fetching basic questions:", error);
      }
    };

    fetchBasicQuestions();
  }, [storedToken]);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fullAddressFromPreviousScreen = useSelector(
    (state) => state.dexterrPortfolio.fullAddress
  );
  console.log(fullAddressFromPreviousScreen);
  const refreshToken = useSelector(selectRefreshToken);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const handleTaxStatusChange = (e) => {
    setTaxStatus(e.target.value);
  };

  const handleTaxStatusListShow = () => {
    if (showSuggestionsTaxStatus) {
      setSuggestionsTaxStatus([]);
      setShowSuggestionsTaxStatus(false);
    } else {
      if (residentType !== "Resident Indian") {
        setSuggestionsTaxStatus(NRIStatus);
        setShowSuggestionsTaxStatus(true);
      } else {
        setShowSuggestionsTaxStatus(
          (prevShowSuggestionsTaxStatus) => !prevShowSuggestionsTaxStatus
        );
      }
    }
  };

  const handleTaxStatusSuggestionClick = (selectedTaxStatus) => {
    console.log("Selected TaxStatus:", selectedTaxStatus);
    setTaxStatus(selectedTaxStatus);
    setSuggestionsTaxStatus([]);
    setShowSuggestionsTaxStatus(false);
  };

  const handleSubmit = async () => {
    if (!TaxStatus || !Residency ) {
      toast.error("Please fill all the required details");
      return;
      // setApiCallsInProgress(apiCallsInProgress - 1);
    }

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      setApiCallsInProgress(apiCallsInProgress + 1);

      const fullAddressValue = `${fullAddressFromPreviousScreen} ${pincode} ${TaxStatus}`;


      let nseTaxStatusCode = "";
      if (TaxStatus === "NRI Repatriable") {
        nseTaxStatusCode = "21";
      } else if (TaxStatus === "NRI Through NRO A/c") {
        nseTaxStatusCode = "11";
      }
      let nseNriTaxResidencyOtherThanIndia = Residency === "Yes" ? "Y" : "N";
      let nseNriCountryTaxResidency1 = "";
      let nseNriUSAPerson = "";

      if (Residency === "Yes") {
        nseNriTaxResidencyOtherThanIndia = "Y";
        nseNriCountryTaxResidency1 = SuggestionsCountryCode;
        if (nseNriCountryTaxResidency1 === "USA") {
          nseNriUSAPerson = "Y";
        }
      } else {
        nseNriTaxResidencyOtherThanIndia = "N";
        nseNriCountryTaxResidency1 = "IND"; 
        nseNriUSAPerson = "N";

      }

      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          country_code: "+91",
          mobileNumber: phoneNumber,
          pan: panNumber,
          // zip: pincode,
          nseNriFullAddress: fullAddressValue,
          nseTaxStatusCodeDescription: TaxStatus,
          nseTaxStatusCode: nseTaxStatusCode,
          nseNriTaxResidencyOtherThanIndia:nseNriTaxResidencyOtherThanIndia,
          nseNriCountryTaxResidency1:  nseNriCountryTaxResidency1,
        ...(Residency === "Yes" && { nseNriCountryTaxResidency1 }),
        nseNriUSAPerson: nseNriUSAPerson,
        },
      };
      console.log(requestBody)

      const response = await axios.post(firstapi, requestBody, { headers });
      console.log("First API Response:", response.data);
      if (Residency === "Yes") {
        nseNriTaxResidencyOtherThanIndia = "Y";
        // nseNriCountryTaxResidency1 = SuggestionsCountryCode;
        // if (nseNriCountryTaxResidency1 === "USA") {
        //   nseNriUSAPerson = "Y";
          Navigate(ROUTE_NRI_TAXID_NUMBER)
        // }
        
      } 
      else if (response.status === 200)  {
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            country_code: "+91",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };
        // setApiCallsInProgress(apiCallsInProgress - 1);

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });



        if (
              thirdResponse.data.statusCode === 200 &&
              thirdResponse.data.status === true
            ) 
            {
              setApiCallsInProgress(apiCallsInProgress + 1);
              console.log("3")
    
              if (
                thirdResponse.data.body.bankAccountNumber === "" ||
                thirdResponse.data.body.bankIfscCode === "" ||
                thirdResponse.data.body.bankAccountType === "" ||
                thirdResponse.data.body.bankName === "" ||
                thirdResponse.data.body.bankBranchName === "" ||
                thirdResponse.data.body.bankBranchAddress === "" ||
                thirdResponse.data.body.bankCodeNSE === "" ||
                thirdResponse.data.body.bankCodeBillDesk === "" ||
                thirdResponse.data.body.bankAccountHolderName === ""
              ) {
                Navigate(ROUTE_ACCOUNT_TYPE);
              } else if (
                (thirdResponse.data.body.bankAccountNumber !== "" ||
                thirdResponse.data.body.bankIfscCode !== "" ||
                thirdResponse.data.body.bankAccountType !== "" ||
                thirdResponse.data.body.bankName !== "" ||
                thirdResponse.data.body.bankBranchName !== "" ||
                thirdResponse.data.body.bankBranchAddress !== "" ||
                thirdResponse.data.body.bankCodeNSE !== "" ||
                thirdResponse.data.body.bankCodeBillDesk !== "" ||
                thirdResponse.data.body.bankAccountHolderName !== "" ||
                  null) &&
                (thirdResponse.data.body.bankVerified.account_exists !==
                  "True" ||
                  thirdResponse.data.body.bankVerified.message !== "success")
              ) {
                Navigate(ROUTE_ACCOUNT_TYPE);
              } else if (
                thirdResponse.data.body.panDetails.gender === "" ||
                thirdResponse.data.body.panDetails.title === "" ||
                thirdResponse.data.body.panDetails.dob === ""
              ) {
                Navigate(Gender_Dob_Verification);
              } else if (
                thirdResponse.data.body.panDetails.addr1 === "" ||
                thirdResponse.data.body.panDetails.addr2 === "" ||
                thirdResponse.data.body.panDetails.city === "" ||
                thirdResponse.data.body.panDetails.state === "" ||
                thirdResponse.data.body.panDetails.pincode === "" ||
                thirdResponse.data.body.panDetails.country === "" ||
                thirdResponse.data.body.panDetails.fullAddress === ""
              ) {
                Navigate(Address_Verification);
              } else if (
                thirdResponse.data.body.nseIncomeCode === "" ||
                thirdResponse.data.body.nseIncomeCodeDescription === "" ||
                null ||
                thirdResponse.data.body.nseOccupationCode === "" ||
                thirdResponse.data.body.nseOccupationCodeDescription === "" ||
                null
              ) {
                Navigate(ROUTE_OCCUPATION);
              } else if (
                thirdResponse.data.body.placeOfBirth === "" ||
                thirdResponse.data.body.nseCountryCodeOfBirth === "" ||
                thirdResponse.data.body.nseCountryOfBirth === ""
              ) {
                Navigate(ROUTE_PLACEOF_BIRTH);
              } else if (
                thirdResponse.data.body.politicallyExposedPerson === "" ||
                thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""
              ) {
                Navigate(ROUTE_CHECKBOXES);
              } else if (
                thirdResponse.data.body.nomineeDob !== "" &&
                thirdResponse.data.body.nomineeName === ""
              ) {
                Navigate(ROUTE_NOMINEE_DETAILS);
              } else if (
                thirdResponse.data.body.nomineeName !== "" &&
                thirdResponse.data.body.nomineeDob === ""
              ) {
                Navigate(ROUTE_NOMINEE_DETAILS);
              } else if (
                thirdResponse.data.body.nomineeName !== "" &&
                thirdResponse.data.body.nomineeType !== "" &&
                thirdResponse.data.body.nomineeRelationShip !== "" &&
                thirdResponse.data.body.nomineeDob !== "" &&
                thirdResponse.data.body.nomineeVerified === "N"
              ) {
                console.log("first");
                Navigate(ROUTE_NOMINEE_SENDOTP);
              }
              
              else if (
                thirdResponse.data.body.nseTaxStatusCode === "" &&
                thirdResponse.data.body.nseTaxStatusCodeDescription === "" &&
                thirdResponse.data.body.nseNriTaxResidencyOtherThanIndia === ""
              ) {
                
                Navigate(ROUTE_NRI_TaxResidency);
              }
             else {
              setApiCallsInProgress(apiCallsInProgress - 1);
              console.log("FROM HERE")
              Navigate(ROUTE_DXTER_SCANNING)
             }
              
              // Navigate(ROUTE_DXTER_SCANNING)
              console.log("Third API call successful");
              // Toast.success("Third API call successful", "success");
            }
            
            else {
              Toast.error(
                thirdResponse.data.message + " " + thirdResponse.data.errorMessage
              );
            }

      }
      else {
        Toast.error(
          firstapi.data.message + " " + firstapi.data.errorMessage
        );
      }
      
      
      setApiCallsInProgress(apiCallsInProgress + 1);

      // Navigate(ROUTE_PLACEOF_BIRTH);
    } catch (error) {
      console.error("Error submitting data:", error);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
          "Error"
      );
    }
  };
  const handleResidencyStatusChange = (e) => {
    setResidencyStatus(e.target.value);
  };

  const handleResidencyStatusListShow = () => {
    setShowSuggestionsResidency(!showSuggestionsResidency);
  };

  const handleResidencySuggestionClick = (selectedResidency) => {
    setResidencyStatus(selectedResidency);
    setShowSuggestionsResidency(false);
  };
  return (
    <div className="NRI_TR_Main_Container">
      <div className="NRI_TR_VrifyOtp_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="NRI_TR_Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo"/>
        </div>
      </div>
      <div className="NRI_TR_AddressLine_Container">
        <div className="NRI_TR_Input_Filed_Box">
          <span className="NRI_TR_Enter_mobile_text">Tax Status</span>
          <div className="NRI_TR_Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.TaxStatus ? classes.Error : ""
              }`}
              value={TaxStatus}
              onChange={handleTaxStatusChange}
            />
            <button
              className={classes.DropDown_button}
              onClick={handleTaxStatusListShow}
            ></button>
            {showSuggestionsTaxStatus && SuggestionsTaxStatus.length > 0 && (
              <div className={classes.Suggestions_Container}>
                {SuggestionsTaxStatus.map((suggestion, index) => (
                  <div
                    key={index}
                    className={classes.Suggest_Suggestion}
                    onClick={() => {
                      handleTaxStatusSuggestionClick(suggestion);
                      setShowSuggestionsTaxStatus(false);
                    }}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {formErrors.TaxStatus && (
          <span className={classes.Error_Message}>{formErrors.TaxStatus}</span>
        )}
        <div className="NRI_TR_Input_Filed_Box2">
          <span className="NRI_TR_Enter_mobile_text2">
            Tax Residency other than India
          </span>
          <div className="NRI_TR_Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.Residency ? classes.Error : ""
              }`}
              value={Residency}
              onChange={handleResidencyStatusChange}
            />
            <button
              className={classes.DropDown_button}
              onClick={handleResidencyStatusListShow}
            ></button>
            {showSuggestionsResidency && (
              <div className={classes.Suggestions_Container}>
                {["Yes", "No"].map((suggestion, index) => (
                  <div
                    key={index}
                    className={classes.Suggest_Suggestion}
                    onClick={() => handleResidencySuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {formErrors.Residency && (
          <span className={classes.Error_Message}>{formErrors.Residency}</span>
        )}
        <div className="NRI_TR_Input_Filed_Box3">
          <span className="NRI_TR_Enter_mobile_text3">
            Country of Tax Residency
          </span>
          <div className="NRI_TR_Input_Inner_Container3">
            {Residency === "Yes" ? (
              <>
                <input
                  className={`${classes.Input_Filed} ${
                    formErrors.CountryOfResidency ? classes.Error : ""
                  }`}
                  value={CountryOfResidency}
                  onChange={handleCountryOfResidencyChange}
                />
                <button
                  className={classes.DropDown_button}
                  onClick={handleCountryOfResidencyListShow}
                ></button>
                {showSuggestionsCountry && (
                  <div className={classes.Suggestions_Container}>
                    {BirthCountryCode.filter(
                      (country) => country.name !== "India"
                    ).map((country, index) => (
                      <div
                        key={index}
                        className={classes.Suggest_Suggestion}
                        onClick={() =>
                          handleCountryOfResidencySuggestionClick(country.name)
                        }
                      >
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <input
                className={`${classes.Input_Filed} ${
                  formErrors.CountryOfResidency ? classes.Error : ""
                }`}
                value="India"
                readOnly
              />
            )}
          </div>
        </div>

        <button className="Submit_button" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default TaxResidencyNRI;
